import { render } from "./DownloadApp.vue?vue&type=template&id=6ca4fdea"
import script from "./DownloadApp.vue?vue&type=script&lang=js"
export * from "./DownloadApp.vue?vue&type=script&lang=js"

import "./DownloadApp.vue?vue&type=style&index=0&id=6ca4fdea&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__